/**
 * Helpers for the retailer-based conditional outcome (retailer-matching-rule).
 *
 * The persisted `ruleData` shape for retailer conditions:
 *   {
 *     keywords: string[],              // selected retailer names
 *   }
 *
 * Simpler than store groups - no metadata snapshot or selection types needed.
 */

export const RETAILER_RULE_SLUG = "retailer-matching-rule";

/**
 * Builds the persisted `ruleData` from a retailer selection.
 *
 * @param {string[]} selectedRetailers - Array of retailer names
 * @returns {{ keywords: string[] }}
 */
export const buildRetailerRuleData = (selectedRetailers = []) => {
  return {
    keywords: selectedRetailers.filter(Boolean),
  };
};

/**
 * Reconstructs the UI selection from persisted `ruleData` for edit mode.
 *
 * @param {object} ruleData
 * @returns {string[]} - Array of selected retailer names
 */
export const getRetailerSelectionFromRuleData = (ruleData) => {
  return ruleData?.keywords || [];
};

/**
 * A retailer condition is configured once at least one retailer has been selected.
 */
export const isRetailerConditionConfigured = (ruleData) => {
  return Array.isArray(ruleData?.keywords) && ruleData.keywords.length > 0;
};
